export default __webpack_public_path__ + "static/media/ma-cotation-logo.8798204c.svg";